import { all, fork } from 'redux-saga/effects'

import changeProTrack from 'store/entities/onBoarding/saga/changeProTrack'
import addMobileNumberSaga from 'store/entities/onBoarding/saga/addMobileNumberSaga'

export function* onboardingSaga() {
  yield all([fork(changeProTrack), fork(addMobileNumberSaga)])
}
